import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';
import { IOutputData, SplitAreaDirective, SplitComponent } from 'angular-split';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { defaultSize, MSplitLayoutService } from './split-layout.service';
import { IMSplitDirection } from './typings';

@Component({
  selector: 'm-split-layout',
  template: `
    <as-split unit="percent" [direction]="mDirection" (dragStart)="dragStart()" (dragEnd)="dragEnd($event)" #splitRef="asSplit">
      <as-split-area [size]="splitLayoutService.leftArea$ | async" #area1Ref="asSplitArea">
        <div [class.m-split-layout-drag-overlay]="dragging"></div>
        <ng-content select="[mArea=left]"></ng-content>
      </as-split-area>
      <as-split-area [size]="splitLayoutService.rightArea$ | async" #area2Ref="asSplitArea">
        <ng-content select="[mArea=right]"></ng-content>
      </as-split-area>
    </as-split>
  `,
  host: {
    class: 'm-split-layout'
  }
})
export class MSplitLayoutComponent implements OnDestroy, OnChanges {
  @Input() mDirection: IMSplitDirection = 'horizontal';
  @Input() mSizes = { area1: defaultSize.area1, area2: defaultSize.area2 };

  @ViewChild('splitRef') splitRef!: SplitComponent;
  @ViewChild('area1Ref') area1Ref!: SplitAreaDirective;
  @ViewChild('area2Ref') area2Ref!: SplitAreaDirective;

  dragging = false;

  private destroy$ = new Subject<void>();

  constructor(public splitLayoutService: MSplitLayoutService, cdr: ChangeDetectorRef) {
    this.splitLayoutService.direction$.pipe(takeUntil(this.destroy$)).subscribe(direction => {
      this.mDirection = direction;
      cdr.detectChanges();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { direction, mSizes } = changes;
    if (direction) {
      this.splitLayoutService.direction$.next(this.mDirection);
    }
    if (mSizes) {
      this.splitLayoutService.leftArea$.next(this.mSizes.area1);
      this.splitLayoutService.rightArea$.next(this.mSizes.area2);
    }
  }

  dragStart(): void {
    this.dragging = true;
  }

  dragEnd({ sizes }: IOutputData): void {
    this.dragging = false;
    this.splitLayoutService.leftArea$.next(sizes[0] as number);
    this.splitLayoutService.rightArea$.next(sizes[1] as number);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
